module.exports = __webpack_public_path__ + "img/showModel1_bottom.ee503823.png";